/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerDeviceLogRequestDto } from '../models/EntityModelResponseContainerDeviceLogRequestDto';
import type { EntityModelResponseContainerListDeviceLogRequestListDto } from '../models/EntityModelResponseContainerListDeviceLogRequestListDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemDeviceLogControllerService {
    /**
     * @returns EntityModelResponseContainerListDeviceLogRequestListDto OK
     * @throws ApiError
     */
    public static listLogs({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<EntityModelResponseContainerListDeviceLogRequestListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/devices/{deviceId}/device-logs',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceLogRequestDto OK
     * @throws ApiError
     */
    public static requestLogs({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<EntityModelResponseContainerDeviceLogRequestDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/devices/{deviceId}/device-logs',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteRequestLog({
        deviceId,
        requestId,
    }: {
        deviceId: number,
        requestId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/devices/{deviceId}/device-logs/{requestId}',
            path: {
                'deviceId': deviceId,
                'requestId': requestId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceLogRequestDto OK
     * @throws ApiError
     */
    public static readRequestLog({
        deviceId,
        requestId,
    }: {
        deviceId: number,
        requestId: number,
    }): CancelablePromise<EntityModelResponseContainerDeviceLogRequestDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/devices/{deviceId}/device-logs/{requestId}',
            path: {
                'deviceId': deviceId,
                'requestId': requestId,
            },
        });
    }
}
